<template>
  <div id="app">
    <app-header v-if="!clean"/>
    <router-view/>
    <app-footer v-if="!clean"/>
  </div>
</template>

<script>
import AppHeader from './components/Header.vue';
import AppFooter from './components/Footer.vue';

export default {
  name: 'App',
  components: { AppHeader, AppFooter },
  computed: {
    clean() {
      return this.$route.matched.some(record => record.meta.clean);
    },
  },
};
</script>

<style lang="less">
  @import './less/gynpad';
  @import './less/common';

  html { font-size: 12px; line-height: 1.5; }

  @media ( max-width: @screen-xs-max ) {
    html { font-size: 11px; }
  }

  @media ( min-width: 420px ) {
    html { font-size: 13px; }
  }

  @media ( min-width: @screen-md-min ) {
    html { font-size: 14px; }
  }

  @media ( min-width: @screen-lg-min ) {
    html { font-size: 16px; }
  }

  #app { font-family: notokr, sans-serif; color: #222222; .rel; letter-spacing: -0.05rem; min-height: 100vh; }
</style>



// WEBPACK FOOTER //
// src/App.vue